'use client';

import type { ReactNode } from 'react';

import { CartContext } from '../hooks/cart-context';
import { useCart } from '../hooks/use-cart';

interface CartProviderProps {
  shopId: string;
  children: ReactNode;
}

export function CartProvider({ shopId, children }: CartProviderProps) {
  const cart = useCart(shopId);

  return <CartContext.Provider value={cart}>{children}</CartContext.Provider>;
}
